// Generated by tools/as3-to-ts from work/decomp/main/scripts/FWP.as (FWP.init_data_arrays, line 9649); hand-edits allowed (see docs/architecture.md)

/** `this.ACHIEV_DEF` literal from FWP.init_data_arrays. Returns a fresh copy on every call (the game mutates it). */
export function create_ACHIEV_DEF(): any {
  return new Array<any>(24, {
    "id": "career",
    "levels": new Array<any>(0, 6, 12, 18, 24, 30, 36, 42, 48, 54, 60, 66, 72, 80, 90, 100),
    "name": "Пройдено карьер"
  }, {
    "id": "missions",
    "levels": new Array<any>(0, 2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 30),
    "name": "Пройдено миссий"
  }, {
    "id": "survival",
    "levels": new Array<any>(0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75),
    "name": "Пройдено выживаний"
  }, {
    "id": "boss",
    "levels": new Array<any>(0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15),
    "name": "Пройдено боссов"
  }, {
    "id": "assault",
    "levels": new Array<any>(0, 3, 10, 25, 40, 100, 250, 600, 1000, 2500, 5000, 10000, 15000, 20000, 25000, 30000),
    "name": "Успешных захватов территорий"
  }, {
    "id": "no_death",
    "levels": new Array<any>(0, 10, 25, 50, 100, 150, 200, 400, 700, 1000, 2000, 3000, 5000, 10000, 20000, 30000),
    "name": "Побед без потери червей"
  }, {
    "id": "no_injure",
    "levels": new Array<any>(0, 5, 10, 15, 30, 50, 75, 100, 200, 300, 500, 1000, 2000, 5000, 10000, 15000),
    "name": "Побед без ранения червей"
  }, {
    "id": "kill_p",
    "levels": new Array<any>(0, 20, 50, 100, 200, 500, 1000, 2000, 3000, 4000, 5000, 10000, 20000, 30000, 40000, 60000),
    "name": "Убито червей снарядами"
  }, {
    "id": "kill_e",
    "levels": new Array<any>(0, 5, 10, 25, 50, 100, 150, 200, 500, 1000, 2000, 3000, 4000, 7000, 10000, 15000),
    "name": "Убито червей взрывчаткой"
  }, {
    "id": "kill_a",
    "levels": new Array<any>(0, 10, 20, 40, 80, 150, 300, 500, 1000, 1500, 3000, 6000, 9000, 12000, 15000, 20000),
    "name": "Убито червей авиаударами"
  }, {
    "id": "kill_c",
    "levels": new Array<any>(0, 5, 10, 15, 30, 50, 80, 150, 300, 500, 800, 1500, 3000, 4500, 6000, 10000),
    "name": "Убито червей в ближнем бою"
  }, {
    "id": "kill_h",
    "levels": new Array<any>(0, 30, 60, 100, 400, 800, 2000, 4000, 10000, 15000, 20000, 25000, 40000, 65000, 80000, 100000),
    "name": "Убито червей энергооружием"
  }, {
    "id": "kill_f",
    "levels": new Array<any>(0, 25, 50, 100, 300, 600, 1000, 2500, 5000, 10000, 15000, 20000, 25000, 30000, 50000, 75000),
    "name": "Убито червей огнест. оружием"
  }, {
    "id": "kill_l",
    "levels": new Array<any>(0, 5, 10, 20, 40, 70, 100, 200, 400, 800, 1500, 3000, 4500, 6000, 8000, 12000),
    "name": "Убито червей живыми бомбами"
  }, {
    "id": "para",
    "levels": new Array<any>(0, 5, 10, 20, 50, 100, 200, 300, 500, 750, 1500, 3000, 5000, 10000, 20000, 30000),
    "name": "Врагов парализовано"
  }, {
    "id": "annih",
    "levels": new Array<any>(0, 2, 5, 10, 20, 30, 50, 100, 200, 350, 600, 1000, 2000, 3000, 5000, 10000),
    "name": "Врагов испарено"
  }, {
    "id": "recipes",
    "levels": new Array<any>(0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 70, 80, 88),
    "name": "Открыто рецептов"
  }, {
    "id": "stims",
    "levels": new Array<any>(0, 3, 6, 10, 20, 50, 100, 250, 500, 1000, 2000, 4000, 8000, 15000, 30000, 50000),
    "name": "Использовано стимуляторов"
  }, {
    "id": "buys",
    "levels": new Array<any>(0, 5, 10, 20, 40, 100, 200, 400, 700, 1000, 1500, 2000, 3000, 4000, 5000, 8000),
    "name": "Куплено оружия"
  }, {
    "id": "steal",
    "levels": new Array<any>(0, 2, 5, 10, 15, 30, 50, 75, 100, 200, 400, 1000, 1500, 2000, 2500, 4000),
    "name": "Оружия украдено"
  }, {
    "id": "crafted",
    "levels": new Array<any>(0, 3, 6, 10, 15, 20, 40, 70, 100, 200, 300, 500, 800, 1500, 3000, 5000),
    "name": "Скрафтено оружия"
  }, {
    "id": "upgraded",
    "levels": new Array<any>(0, 3, 5, 10, 20, 30, 50, 100, 150, 300, 500, 750, 1000, 2000, 4000, 8000),
    "name": "Улучшено оружия"
  }, {
    "id": "wins",
    "levels": new Array<any>(0, 5, 10, 25, 40, 75, 100, 135, 200, 300, 400, 600, 1000, 2000, 3000, 5000),
    "name": "Выигрышей в дартс"
  }, {
    "id": "days",
    "levels": new Array<any>(0, 30, 60, 90, 120, 180, 240, 360, 450, 540, 630, 720, 810, 900, 990, 1080),
    "name": "Дней в игре"
  });
}
